import { render, staticRenderFns } from "./offersBoard.vue?vue&type=template&id=645bc436&scoped=true&"
import script from "./offersBoard.vue?vue&type=script&lang=js&"
export * from "./offersBoard.vue?vue&type=script&lang=js&"
import style0 from "./offersBoard.vue?vue&type=style&index=0&id=645bc436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645bc436",
  null
  
)

export default component.exports